// extracted by mini-css-extract-plugin
export var cookiesModule = "main-layout-module--cookies-module---fzIj";
export var layout = "main-layout-module--layout--tSqQB";
export var main = "main-layout-module--main--j-kQy";
export var overflow = "main-layout-module--overflow--OlRHM";
export var overflowY = "main-layout-module--overflow-y--Rtu15";
export var paddingTop = "main-layout-module--padding-top--uriDY";
export var survey = "main-layout-module--survey--orVpr";